// extracted by mini-css-extract-plugin
export default {"tabs":"z8-z","tablist":"A8-z","tablistItem":"B8-z"};